import React, { createContext, useState, useLayoutEffect } from 'react';

const LayoutContext = createContext({
  status: 'search', //'search' 'rp' 'simul', 'routeNear'
  chgStatus: () => {},
});


const SideBarContext = createContext({
  sidebar: true,
  lnb:false,
  toggle: () => {},
});



const globalContext = createContext({
    lang: '',
    currentLangData: {},
    currentLocation:{},
    toggleLang: () => {},
});

  
function LayoutProvider (props) {
  //const [status, setStatus] = useState('search');
  const [status, setStatus] = useState('search');
  const [sidebar, setSidebar] = useState(true);
  const [lnb, setLnb] = useState(false);
  const [lang, setLang] = useState("KR");
  const [currentLocation, setLocation] = useState({});
    
  const chgStatus = (status) => {
    setStatus(status);
  };

  const toggle = (id) => {
    if(id==="sidebar"){
      setSidebar(!sidebar);
    } else{
      setLnb(!lnb);
    } 
  };

  const toggleLang = (ln) => {
    setLang(ln);
  };


  useLayoutEffect(() => {
    setStatus(status);
  }, [status]);


  return (
    <LayoutContext.Provider value={{ status, chgStatus, }}>
      <SideBarContext.Provider value={{ sidebar, lnb, toggle, }}>
        <globalContext.Provider value={{ lang, toggleLang, currentLangData: langData[lang],currentLocation,setLocation }}>
        {props.children}
        </globalContext.Provider>
      </SideBarContext.Provider>
    </LayoutContext.Provider>
  )
}


const langData = {
  'kr': {
    main: {
      title: '타이틀',
    },
  },
  'en': {
    main: {
      title: 'title',
    },
  },
}

export { LayoutContext, SideBarContext, globalContext, LayoutProvider };
